// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/approval-workflows",
  ListShort: "/pyr/approval-workflows/short",
  Create: "/pyr/approval-workflows",
  Update: "/pyr/approval-workflows",
  Detail: "/pyr/approval-workflows",
};
